// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__BmVPj","alertIcon":"ConfirmModal_alertIcon__1qs4D"};